let uniqueIdCounter = 0;

/** @returns {string} a unique id string with the given prefix */
export const uniqueId = (prefix?: string): string =>
  `${prefix == null ? '' : prefix}${++uniqueIdCounter}`;
